import { useRef } from "react";
import { toast } from "sonner";
import { Camera, X } from "lucide-react";
import { compressImage } from "../../lib/api";

export function PhotoInput({ label, value, onChange, testid, max = 3 }) {
  const ref = useRef(null);
  const add = async (e) => {
    const files = Array.from(e.target.files || []).filter((f) => f.type.startsWith("image/"));
    e.target.value = "";
    const room = max - value.length;
    if (files.length > room) toast.info(`${max} photos maximum.`);
    try {
      const imgs = await Promise.all(files.slice(0, room).map((f) => compressImage(f)));
      onChange([...value, ...imgs]);
    } catch {
      toast.error("Impossible de lire cette image.");
    }
  };
  return (
    <div>
      <span className="mb-1.5 block text-sm font-semibold text-slate-700">{label}</span>
      <div className="flex flex-wrap gap-2">
        {value.map((src, i) => (
          <div key={i} className="relative h-20 w-20 overflow-hidden rounded-xl ring-1 ring-slate-200">
            <img src={src} alt={`${label} ${i + 1}`} className="h-full w-full object-cover" />
            <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} className="absolute right-1 top-1 grid h-6 w-6 place-items-center rounded-full bg-ag-ink/80 text-white" aria-label="Retirer la photo" data-testid={`${testid}-remove-${i}`}><X className="h-3 w-3" /></button>
          </div>
        ))}
        {value.length < max && (
          <button type="button" onClick={() => ref.current?.click()} className="grid h-20 w-20 place-items-center rounded-xl border-2 border-dashed border-ag-blue/40 text-ag-blue transition-colors hover:bg-ag-mist" aria-label={`Ajouter : ${label}`} data-testid={`${testid}-button`}>
            <Camera className="h-6 w-6" />
          </button>
        )}
      </div>
      <input ref={ref} type="file" accept="image/*" multiple className="hidden" onChange={add} data-testid={`${testid}-input`} />
    </div>
  );
}
